import { Dropdown } from 'react-bootstrap';
import {
    ProfileButtonDropdownStyled,
    ProfileButtonPanelWrapper,
    ProfileButtonToggleStyled,
    ZendeskButtonWrapper
} from './styled/ProfileButtonStyled';
import { memo, useCallback, useEffect, useMemo } from 'react';
import { useResponsive } from '../../../../components/responsive';
import { createStructuredSelector } from 'reselect';
import { getUserRecents } from '../../../../app/appSelectors';
import { logoutAction } from '../../../Login/loginActions';
import { openModalAction, setRecentDoneAction } from '../../../../app/appActions';
import { connect } from 'react-redux';
import { showWatchMoreVideosLaterTooltipAction } from '../../../Tutorials/tutorialsActions';
import { ZendeskButton } from '../../../Zendesk/components/ZendeskButton';
import { isClientMobile } from '../../../../components/ClientInfo/ClientInfo';
import { getPayoutParamsAction } from '../../accountActions';
import { getPayoutParams } from '../../accountSelectors';
import { ProfileIcon } from './ProfileIcon';
import { ProfileVerifyAlert } from "./ProfileVerifyAlert";
import { Slider } from "../../../../components/Slider/Slider";
import { getPartnerParams } from "../../../Partner/partnerSelectors";
import ProfileButtonEmail from "./ProfileButtonEmail/ProfileButtonEmail";
import DropdownMenuItems from "./DropdownMenuItems.jsx";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext.js";
import { getIsRespawnAvailable } from "../../../Bonus/bonusesSelectors";

const SupportMenu = memo(({children}) => {
    return <ZendeskButtonWrapper>
        <ZendeskButton iconFontSize="16px" iconColor="#7D86B2"
                       style={{color: 'var(--color-white)'}}>
            {children}
        </ZendeskButton>
    </ZendeskButtonWrapper>
});

const ProfileButton = memo((props) => {
    const {
        getPayoutParams,
        isRespawnAvailable,
        logout,
        openModal,
        onOpenCallback,
        payoutParams,
        className,
        partnerParams,
        recents,
        setRecentDone,
    } = props;
    const {isSmallMaxWidth} = useResponsive();
    const {getLangPath} = useLangContext();
    const tutorialLink = useMemo(() => getLangPath('video_tutorial.link'), [getLangPath]);

    useEffect(() => {
        getPayoutParams();
    }, [getPayoutParams]);

    const handleDropdownToggle = useCallback((show) => {
        if (show && onOpenCallback) {
            onOpenCallback();
        }
    }, [onOpenCallback]);

    const handleLogoutClick = useCallback(() => {
        logout({source: 'LogoutButton'});
    }, [logout]);

    const getMenuComponent = useCallback((name) => {
        switch (name) {
            case 'support':
                return SupportMenu
            default:
                return null;
        }
    }, []);

    const isShowMenuItem = useCallback((name) => {
        switch (name) {
            case 'partner':
                return partnerParams.active;
            case 'respawn':
                return isRespawnAvailable;
            case 'tutorials':
                return !isClientMobile && tutorialLink;
            case 'support':
                return isClientMobile;
            default:
                return true;
        }
    }, [partnerParams, isRespawnAvailable, tutorialLink]);

    const isShowProfileIndicator = typeof payoutParams?.verify === 'boolean' && !payoutParams.verify

    const getDropdownItems = useCallback(() => {
        return <>
            <ProfileButtonPanelWrapper>
                <ProfileButtonEmail/>
            </ProfileButtonPanelWrapper>
            {!payoutParams.verify
                ? <ProfileButtonPanelWrapper>
                    <ProfileVerifyAlert show/>
                </ProfileButtonPanelWrapper>
                : <Dropdown.Divider/>
            }

            <DropdownMenuItems isShowMenuItem={isShowMenuItem}
                               getMenuComponent={getMenuComponent}
                               openModal={openModal}
                               recents={recents}
                               setRecentDone={setRecentDone}
            />

            <Dropdown.Item onClick={handleLogoutClick} className={'secondary'}>
                {getLangPath('menu.log_out')}
            </Dropdown.Item>
        </>;
    }, [payoutParams, isShowMenuItem, getMenuComponent, openModal, recents, setRecentDone, handleLogoutClick, getLangPath]);

    return isSmallMaxWidth ? (
        <Slider
            toggleComponent={
                <ProfileButtonToggleStyled className={className}>
                    <ProfileIcon showIndicator={isShowProfileIndicator}/>
                </ProfileButtonToggleStyled>
            }
            toggleWrapperClassname="flex-grow-0"
        >
            <Slider.CloseWrapper>
                {getDropdownItems()}
            </Slider.CloseWrapper>
        </Slider>
    ) : (
        <Dropdown as={ProfileButtonDropdownStyled} onToggle={handleDropdownToggle}>
            <Dropdown.Toggle as={ProfileButtonToggleStyled} id="dropdown-basic" className={className}>
                <ProfileIcon showIndicator={isShowProfileIndicator} showArrow/>
            </Dropdown.Toggle>

            <Dropdown.Menu>
                {getDropdownItems()}
            </Dropdown.Menu>
        </Dropdown>
    );
});

const mapStateToProps = createStructuredSelector({
    isRespawnAvailable: getIsRespawnAvailable,
    partnerParams: getPartnerParams,
    payoutParams: getPayoutParams,
    recents: getUserRecents,
});

const mapDispatchToProps = (dispatch) => ({
    logout: (payload) => dispatch(logoutAction(payload)),
    openModal: (payload) => dispatch(openModalAction(payload)),
    onOpenCallback: () => dispatch(showWatchMoreVideosLaterTooltipAction(false)),
    getPayoutParams: payload => dispatch(getPayoutParamsAction(payload)),
    setRecentDone: payload => dispatch(setRecentDoneAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfileButton);